// The destination is fixed and carries no session, customer or DNS data.
export const DOMAIN_PORTAL_URL = 'https://domains.scaleplus.gg/';
export const DOMAIN_GUIDE_URL = 'https://domains.scaleplus.gg/help';
export const DOMAIN_PORTAL_FLAG = 'VUE_APP_UNIFIED_DOMAINS_ENABLED';

export function domainPortalEnabled(config = typeof window === 'undefined' ? {} : window.gdEnv || {}) {
  return config[DOMAIN_PORTAL_FLAG] === true || config[DOMAIN_PORTAL_FLAG] === 'true';
}

export function withDomainPortalMenu(items, { enabled = domainPortalEnabled(), labels = [], navigate } = {}) {
  if (!enabled || !Array.isArray(items)) return items;
  const callback = navigate || (() => {
    if (typeof window !== 'undefined') window.location.assign(DOMAIN_PORTAL_URL);
  });
  const domainLabels = ['Domains', 'frontend_baselayout_domains', 'frontend_baselayout_settings_domains', ...labels];
  const matches = item => item && domainLabels.some(label => typeof item.text === 'string' && item.text.trim() === label);
  if (items.some(matches)) return items.map(item => matches(item) ? { ...item, callback } : item);
  const firstDivider = items.findIndex(item => item && item.text === 'ruler');
  const position = firstDivider < 0 ? items.length : firstDivider;
  return [...items.slice(0, position), { text: 'Domains', callback }, ...items.slice(position)];
}
